export interface IAppConfig {
  environment?: string;
  session?: {
    baseUrl: string;
    getMaterData: string;
    getAllCoordinators: string;
    getCompanies: string;
    getPPMDs: string;
    getEditSession: string;
    addOrUpdateSession: string;
    getSessionSearchData: string;
    sessionExport: string;
    getSubscriptionMetaData: string;
    getLoggedInUserRoleList: string;
    updateHighestUserRole: string;
    sessionAuditTrailExport: string;
    deloitteDomain: string;
    isUserExist: string;
    exportSubsUsageReport: string;
    signout: string;
    CreateAcknolwedgementEmail: string;
    logout: string;
    getSessionsForSubAssociation: string;
    assignSessionsForSubAssociation: string;
    GetWBSCodes: string;
    GetUserSpecificSearchGrid: string;
    SaveUserSpecificSearchGrid: string;
  };
  facilitator?: {
    baseUrl: string;
    getFacilitators: string;
    getExportData: string;
    searchFacilitator: string;
    saveFacilitator: string;
  };
  subscription?: {
    baseUrl: string;
    mainbaseUrl: string;
    getSubDomains: string;
    saveOrUpdateSubscription: string;
    getEditSubscription: string;
    getSubscriptionAdmins: string;
    getOpenSubscriptionPricingInformationDetails: string;
    getSubscriptionSearchResults: string;
    exportSubscriptionData: string;
    getAdminRoles: string;
    downloadAcknowledgement: string;
  };
  organization?: {
    baseUrl: string;
    getCompaniesList: string;
    saveCompanyDetails: string;
    verifyCompany: string;
  };
  security?: {
    baseUrl: string;
    users: string;
    SaveSecurityData: string;
    audittrails: string;
    GetPreview: string;
    GetUserListForAddingCountryAdmin: string;
    GetData: string;
    save: string;
    SaveBulkSecurityData: string;
    FacilitatorReport: string;
    GetExcelReport: string;
    ExcelReport: string;
  };
  assessment?: {
    baseUrl: string;
    mainAPIBaseUrl: string;
    getAssessmentData: string;
    getTeamSnapshotDataUsingUID: string;
    assessmentExport: string;
    savePDFSerach: string;
    downloadTeamSnapshotPDF: string;
    updateEmail: string;
    getSessionsList: string;
    copyFromAssessment: string;
    downloadPDF: string;
  };
  report?: {
    baseUrl: string;
    getSetReport: string;
    getSet: string;
  };
  emailTemplate?: {
    baseUrl: string;
    getEmailTemplate: string;
    getEmailTemplates: string;
    emailTrigger: string;
    updateEmailTemplate: string;
  };
  dataCleanUp?: {
    baseUrl: string;
    dataCleanUp: string;
    getUserDetails: string;
  };
  updateCountryMailbox?: {
    baseUrl: string;
    updateCountryMailbox: string;
  };
  postLogoutRedirectUri?: string;
  resources?: {
    baseUrl: string;
    getResources: string;
    addResource: string;
    updateSortOrder: string;
  };
  searchCount?: string;
  MDMWBSdeploymentDate?: string;
  isProduction?: boolean;
  mainAppUrl?: string;
  msal?: {
    auth: {
      clientId: string;
      authority: string;
      redirectUri: string;
      postLogoutRedirectUri: string;
      navigateToLoginRequestUrl: boolean;
    };
    cache: {
      cacheLocation: string;
    };
    guard: {
      interactionType: string;
      authRequest: {
        scopes: string[];
      };
    };
    interceptor: {
      interactionType: string;
      protectedResourceMap: [string, string[]][];
    };
  };
}

export const AppConfig: IAppConfig =
{
  "environment": "qas",
  "session": {
    "baseUrl": "https://qeusses.admin.api.bc.deloitte.com/",
    "getMaterData": "api/GetMasterData",
    "getAllCoordinators": "api/AllCoordinators",
    "getCompanies": "api/GetCompanies",
    "getPPMDs": "api/GetPPMDs",
    "getEditSession": "api/GetEditSession",
    "addOrUpdateSession": "api/AddOrUpdateSession",
    "getSessionSearchData": "api/GetSessionSearchResult",
    "sessionExport": "api/SessionExport",
    "getSubscriptionMetaData": "api/GetSubscriptionMetaData",
    "getLoggedInUserRoleList": "api/GetLoggedInUserRoleList",
    "updateHighestUserRole": "api/UpdateHighestUserRole",
    "sessionAuditTrailExport": "api/SessionAuditTrailExport",
    "deloitteDomain": "api/DeloitteDomain",
    "isUserExist": "api/IsUserExist",
    "exportSubsUsageReport": "api/SubscriptionUsageExport",
    "signout": "/api/Account/Signout",
    "CreateAcknolwedgementEmail": "api/CreateAcknolwedgementEmail?subjectName=",
    "logout": "api/Logout",
    "getSessionsForSubAssociation": "api/GetSessionsForSubAssociation",
    "assignSessionsForSubAssociation": "api/AssignSessionsToSubscription",
    "GetWBSCodes": "api/GetWBSCodes",
    "GetUserSpecificSearchGrid": "api/GetUserSpecificSearchGrid",
    "SaveUserSpecificSearchGrid": "api/SaveUserSpecificSearchGrid"
  },
  "facilitator": {
    "baseUrl": "https://qeusfaciltor.admin.api.bc.deloitte.com/",
    "getFacilitators": "api/GetFacilitators",
    "getExportData": "api/ExportPresentersSearchData",
    "searchFacilitator": "api/SearchFacilitator",
    "saveFacilitator": "api/InsertOrUpdatePresenterInfo"
  },
  "subscription": {
    "baseUrl": "https://qeussub.admin.api.bc.deloitte.com/",
    "mainbaseUrl": "https://qeusauth.api.bc.deloitte.com/",
    "getSubDomains": "api/GetSubDomain",
    "saveOrUpdateSubscription": "api/SaveOrUpdateSubscription",
    "getEditSubscription": "api/GetEditSubscription",
    "getSubscriptionAdmins": "api/GetSubscriptionAdmins",
    "getOpenSubscriptionPricingInformationDetails": "api/GetOpenSubscriptionPricingInformationDetails",
    "getSubscriptionSearchResults": "api/GetSubscriptionSearchResults",
    "exportSubscriptionData": "api/ExportSubscriptionData",
    "getAdminRoles": "api/GetAdminRoles",
    "downloadAcknowledgement": "api/CreateAcknolwedgementEmail?subjectName="
  },
  "organization": {
    "baseUrl": "https://qeusorg.admin.api.bc.deloitte.com/",
    "getCompaniesList": "api/GetCompaniesList",
    "saveCompanyDetails": "api/SaveCompanyDetails",
    "verifyCompany": "api/VerifyCompany"
  },
  "security": {
    "baseUrl": "https://qeussec.admin.api.bc.deloitte.com/",
    "users": "api/users",
    "SaveSecurityData": "api/SaveSecurityData",
    "audittrails": "api/audittrails",
    "GetPreview": "api/GetPreview",
    "GetUserListForAddingCountryAdmin": "api/GetUserListForAddingCountryAdmin",
    "GetData": "api/GetData",
    "save": "api/save",
    "SaveBulkSecurityData": "api/SaveBulkSecurityData",
    "FacilitatorReport": "api/FacilitatorReport",
    "GetExcelReport": "api/GetExcelReport",
    "ExcelReport": "api/ExcelReport"
  },
  "assessment": {
    "baseUrl": "https://qeusassmt.admin.api.bc.deloitte.com/",
    "mainAPIBaseUrl": "https://qeuspdf.api.bc.deloitte.com/",
    "getAssessmentData": "api/Search/GetAssessmentResults",
    "getTeamSnapshotDataUsingUID": "api/TeamSnapshot/GetTeamSnapshotData",
    "assessmentExport": "api/Search/AssessmentExport",
    "savePDFSerach": "api/TeamSnapshot/SavePDFSearch",
    "downloadTeamSnapshotPDF": "api/TeamSnapshot/DownloadTeamSnapshotPDF",
    "updateEmail": "api/Assessment/UpdateEmail",
    "getSessionsList": "api/Assessment/GetSessionsList",
    "copyFromAssessment": "api/Assessment/CopyFromAssessment",
    "downloadPDF": "api/PDF/DownloadPDF"
  },
  "report": {
    "baseUrl": "https://qeusrpt.admin.api.bc.deloitte.com/",
    "getSetReport": "api/GetSetReport",
    "getSet": "api/GetSets"
  },
  "emailTemplate": {
    "baseUrl": "https://qeustemplate.admin.api.bc.deloitte.com/",
    "getEmailTemplate": "api/GetEmailTemplate",
    "getEmailTemplates": "api/GetEmailTemplates",
    "emailTrigger": "api/EmailTrigger",
    "updateEmailTemplate": "api/UpdateEmailTemplate"
  },
  "dataCleanUp": {
    "baseUrl": "https://qeusdcp.admin.api.bc.deloitte.com/",
    "dataCleanUp": "api/DataCleanUp",
    "getUserDetails": "api/GetUserDetails"
  },
  "updateCountryMailbox": {
    "baseUrl": "https://qeuseb.admin.api.bc.deloitte.com/",
    "updateCountryMailbox": "api/UpdateCountryMailbox"
  },
  "postLogoutRedirectUri": "https://qbusinesschemistryadmin.deloitte.com",
  "resources": {
    "baseUrl": "https://qeusrsc.admin.api.bc.deloitte.com/",
    "getResources": "api/getResources",
    "addResource": "api/addResource",
    "updateSortOrder": "api/updateSortOrder"
  },
  "searchCount": "15",
  "MDMWBSdeploymentDate": "03-11-2026",
  "isProduction": false,
  "mainAppUrl": "https://qbusinesschemistry.deloitte.com",
  "msal": {
    "auth": {
      "clientId": "26efae3d-c860-408a-a28c-87dc3b058491",
      "authority": "https://login.microsoftonline.com/36da45f1-dd2c-4d1f-af13-5abe46b99921/v2.0",
      "redirectUri": "https://qbusinesschemistryadmin.deloitte.com",
      "postLogoutRedirectUri": "https://qbusinesschemistryadmin.deloitte.com",
      "navigateToLoginRequestUrl": true
    },
    "cache": {
      "cacheLocation": "localStorage"
    },
    "guard": {
      "interactionType": "redirect",
      "authRequest": {
        "scopes": [
          "user.read"
        ]
      }
    },
    "interceptor": {
      "interactionType": "redirect",
      "protectedResourceMap": [
        [
          "https://graph.microsoft.com/v1.0/me",
          [
            "user.read"
          ]
        ],
        [
          "https://qeusses.admin.api.bc.deloitte.com/*",
          [
            "user.read"
          ]
        ],
        [
          "https://qeusfaciltor.admin.api.bc.deloitte.com/*",
          [
            "user.read"
          ]
        ],
        [
          "https://qeusassmt.admin.api.bc.deloitte.com/*",
          [
            "user.read"
          ]
        ],
        [
          "https://qeusrpt.admin.api.bc.deloitte.com/*",
          [
            "user.read"
          ]
        ],
        [
          "https://qeussub.admin.api.bc.deloitte.com/*",
          [
            "user.read"
          ]
        ],
        [
          "https://qeussec.admin.api.bc.deloitte.com/*",
          [
            "user.read"
          ]
        ],
        [
          "https://qeusorg.admin.api.bc.deloitte.com/*",
          [
            "user.read"
          ]
        ],
        [
          "https://qeusdcp.admin.api.bc.deloitte.com/*",
          [
            "user.read"
          ]
        ],
        [
          "https://qeustemplate.admin.api.bc.deloitte.com/*",
          [
            "user.read"
          ]
        ],
        [
          "https://qeuseb.admin.api.bc.deloitte.com/*",
          [
            "user.read"
          ]
        ],
        [
          "https://qeusrsc.admin.api.bc.deloitte.com/*",
          [
            "user.read"
          ]
        ],
        [
          "https://qeuspdf.api.bc.deloitte.com/api/PDF/DownloadPDF",
          [
            "user.read"
          ]
        ],
        [
          "https://qeuspdf.api.bc.deloitte.com/api/TeamSnapshot/SavePDFSearch",
          [
            "user.read"
          ]
        ]
      ]
    }
  }
};
